export const HEALTHCHECK_LABELS = {
  COMMERCIAL_STATE: 'Commercial state:',
  COMMERCIAL_RISKS: 'Commercial Risks:',
  ASSUMPTION: 'Assumption:',
  BILLING: 'Billing:',
  SOW_EXPIRES: 'SOW expires:',
  RISKS: 'Risks:',
  PPC: 'PPC:',
  PRODUCTION_OWNERSHIP: 'Production ownership:',
  PRODUCTION_INCIDENTS: 'Production incidents:',
  PRODUCTION_BUGS: 'Production bugs:',
  BUSINESS_OUTCOMES: 'Business outcomes:',
  MILESTONES: 'Milestones:',
  PROGRESS: 'Progress:',
  BUDGET: 'Budget:',
  TIMELINE: 'Timeline:',
  CUSTOMER_REPORT: 'Customer report:',
  CHANGE_REQUESTS: 'Change requests:',
  STAKEHOLDERS: 'Stakeholders:',
  TEAM: 'Team coverage:',
  ROLES: 'Key roles:',
  REPLACEMENT: 'Replacement:',
  QUALITY: 'Team quality:',
} as const;

export const SECTION_TITLES = {
  REQUIRED_ACTIONS: 'Required actions',
  ESCALATED_COMMERCIAL_RISKS: 'Escalated commercial risks',
  ESCALATED_PROJECT_MANAGEMENT_RISKS: 'Escalated project management risks',
  ESCALATED_ENGINEERING_RISKS: 'Escalated engineering risks',
  ESCALATED_STAFFING_RISKS: 'Escalated staffing risks',
  OTHER_COMMERCIAL_RISKS: 'Other commercial risks',
  OTHER_PROJECT_MANAGEMENT_RISKS: 'Other project management risks',
  OTHER_ENGINEERING_RISKS: 'Other engineering risks',
  OTHER_STAFFING_RISKS: 'Other staffing risks',
  VIOLATED_ASSUMPTIONS: 'Violated assumptions',
  PRODUCTION_INCIDENTS: 'Production incidents',
  PRODUCTION_BUGS: 'Production bugs',
  OUTDATED_MILESTONES: 'Outdated milestones',
  OUTDATED_RISKS: 'Outdated risks',
} as const;

export const EMPTY_MESSAGES = {
  ESCALATED_RISKS: 'Escalated risks not found',
  OTHER_RISKS: 'Other risks not found',
  OUTDATED_MILESTONES: 'Outdated milestones not found',
  VIOLATED_ASSUMPTIONS: 'Violated assumptions not found',
  PRODUCTION_BUGS: 'Production bugs not found',
  PRODUCTION_INCIDENTS: 'Production incidents not found',
} as const;
